import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { FireReceiverSearchType, getFireReceiverSearchTypeName } from "utils/common";
import { getDateTime } from "utils/date";

//화재수신기 설정
export default function FireReceiverSettingsComponent() {
  const itemsPerPage = 100;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("0");
  const [searchText, setSearchText] = useState("");
  const [reportCycle, setReportCycle] = useState(1);
  const [fwDlUrl, setFwDlUrl] = useState("");
  const [reset, setReset] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getFireReceiverSettingListByUrl(url);
      } else {
        result = await dbmsApi.getFireReceiverSettingList(
          selectedSearchType,
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleItemClick = (e, id) => {
    if (!e.target.closest('.serial-number_item')) {
      e.currentTarget.classList.toggle('active');

      if (e.currentTarget.classList.contains('active')) {
        setCheckedIds([...checkedIds, id]);
      } else {
        setCheckedIds(checkedIds.filter((a) => a !== id));
      }
    }
  }

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const openModal = (data) => {
    setSelectedDataSource(data);
    setReportCycle(data.reportCycle);
    setFwDlUrl(data.fwDlUrl);
    setReset(data.reset);

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { status, data } = await dbmsApi.updateFireReceiverSetting(selectedDataSource.id, reportCycle, fwDlUrl, reset);
        if (status === true) {
          alert(`저장을 완료하였습니다.`);
        } else {
          alert(`저장을 실패하였습니다.\n${data}`)
        }
      });
    }
  }

  const onChange = (setter) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setter(value);
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard FRSboard">
        <div class="top_board pc">
          <p class="title_board">화재수신기 설정</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button class="btn_select" onClick={toggleSelectBox}>
                  <p>{getFireReceiverSearchTypeName(selectedSearchType)}</p>
                  <i class="x-icon"></i>
                </button>
                <ul class="list_member">
                  {Object.values(FireReceiverSearchType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getFireReceiverSearchTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">화재수신기 설정</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board">
          <div class="wrap_table scroll_table">
            <div class="containerTable dbmsTable frsTable dbmsTabTable">
              <ul class="head_table">
                <li>
                  <p>관리 ID</p>
                </li>
                <li>
                  <p>화재수신기 일련번호</p>
                </li>
                <li>
                  <p>화재수신기 DEI</p>
                </li>
                <li>
                  <p>화재수신기 모델코드</p>
                </li>
                <li>
                  <p>화재수신기 상태보고 주기</p>
                </li>
                <li>
                  <p>화재수신기 펌웨어 다운로드</p>
                </li>
                <li>
                  <p>화재수신기 RESET</p>
                </li>
              </ul>

              <div class="body_table">
                <div class="inner_table_wrap">
                  {dataSource.results &&
                    dataSource.results.map((item, index) => (
                      <div class="wrap_table_item" onClick={(e) => handleItemClick(e, item.id)}>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.id}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_02 serial-number_item" onClick={() => openModal(item)}>
                          <p class="cont_table_item">
                            {item.serialNumber}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_03">
                          <p class="cont_table_item">
                            {item.dei}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_04">
                          <p class="cont_table_item">
                            {item.modelCode}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_05">
                          <p class="cont_table_item">
                            {item.reportCycle}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_06">
                          <p class="cont_table_item">
                            {item.fwDlUrl}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_07">
                          <input type="checkbox" class="cont_table_item" checked={item.reset} />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn">양식</button>
            <button class="item_btn">업로드</button>
            <button class="item_btn">다운로드</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal FRSrightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>화재수신기 설정</h2>
              {selectedDataSource && (
                <>
                  <div class="wrap_detail_cont type2">
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">일련번호</p>
                      <div class="detail_box">
                        {selectedDataSource.serialNumber}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">DEI</p>
                      <div class="detail_box">
                        {selectedDataSource.dei}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">모델명</p>
                      <div class="detail_box">
                        {selectedDataSource.modelCode}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">최초 통신 일시</p>
                      <div class="detail_box">
                        {getDateTime(new Date(selectedDataSource.initCommDt))}
                      </div>
                    </div>
                    <div class="wrap_detail_item default_type_item">
                      <p class="title_detail">상태보고 주기(분)</p>
                      <div class="detail_box">
                        <input class="default_input" type="number" min={1} max={255} defaultValue={selectedDataSource.reportCycle} onChange={onChange(setReportCycle)} />
                      </div>
                    </div>
                    <div class="wrap_detail_item default_type_item">
                      <p class="title_detail">펌웨어 다운로드</p>
                      <div class="detail_box">
                        <input class="default_input" type="text" defaultValue={selectedDataSource.fwDlUrl} alue={selectedDataSource.fwDlUrl} onChange={onChange(setFwDlUrl)} />
                      </div>
                    </div>

                    <div class="wrap_detail_item">
                      <p class="title_detail">
                        RESET
                        <input type="checkbox" defaultChecked={selectedDataSource.reset} checked={reset} style={{ display: 'block' }} onChange={onChange(setReset)} />
                      </p>
                    </div>
                  </div>
                </>
              )}
              <div class="wrap_btn_set">
                <button type="submit" class="btn_dark">저장</button>
              </div>
            </form>
          </div>
        )}
      </div >
    </>
  );
}
